import React, { FC } from 'react';
import cx from 'classnames';
import ARIcon from '@/assets/icons/ar.svg';
import { PropsWithClassName } from '@/types/common';
import Asset from '@/components/Common/Asset';
import * as styles from './AR.module.scss';

type Props = PropsWithClassName<{
  content?: Queries.DatoCmsTextAssetGroupFragment | null;
  url?: string;
}>;

const AR: FC<Props> = ({ className, content, url }) => (
  <a
    className={cx(styles.main, className)}
    href={url}
    target="_blank"
    rel="noopener noreferrer"
  >
    <div className={styles.text}>
      <ARIcon />
      <h3 className={styles.title}>{content?.text?.title}</h3>
      <p>{content?.text?.body}</p>
    </div>
    <div className={styles.image}>
      <Asset asset={content?.asset} />
    </div>
  </a>
);

export default AR;
